import { resetAllStores } from '@/pinia/storeRegistry'
import router from '@/router'
import { userAPI } from '@/services-ts/axios'
import type { ILogin } from '@/types/Request'
import type { IAuthStore } from '@/types/Store/State'
import { Hub, RemoveToken, SetMFAData, SetTokens } from '@/utils-ts'
import { TokenManager } from '@/utils-ts/TokenManager'
import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
  state: (): IAuthStore => ({
    user: {},
  }),

  actions: {
    async Login(payload: ILogin) {
      const { status, data } = await userAPI.UserServices.Login(payload)

      if (status && data) {
        if (data.isMFAActive) {
          SetMFAData(data)
          void router.push('/multi-factor-authentication')
        } else {
          SetTokens(data.token, data.refreshToken, data.tokenValidTo, data.refreshTokenValidTo)
          void router.push('/')
        }
      } else if (data?.isPasswordExpired) {
        const token = data.passwordRecoveryToken
        setTimeout(() => {
          void router.push({
            path: `reset-password/${token}/${payload.CompanyCode}/false`,
          })
        }, 2500)
      }
    },

    async GetEmployeeByIdWeb() {
      const { data, status } = await userAPI.EmployeeServices.GetEmployeeByIdWeb()
      if (status) this.user = data
    },

    async Logout() {
      if (this.user.userId) {
        try {
          await userAPI.UserServices.Logout(this.user.userId)
        } catch (error) {
          console.error('Logout API call failed:', error)
        }
      }
      resetAllStores()
      this.user = {
        name: null,
        surname: null,
        genderTypeId: null,
        departmentId: null,
        positionId: null,
        cityId: null,
        activation: null,
        birthdate: null,
        startDate: null,
        email: null,
        phone: null,
        imageUrl: null,
        id: '',
        countryId: null,
        countryName: null,
        cityName: null,
        username: '',
        userId: null,
        positionName: null,
        departmentName: null,
        isPasswordRequired: null,
        languageId: null,
        isDefault: null,
        profileName: '',
        displayCompanyName: null,
        employeeWorkerTypeId: null,
        locationId: null,
        communityId: null,
        locationName: null,
        employeeWorkerTypeName: null,
        isAdmin: null,
        isActive: null,
        userCompanyIds: null,
      }
      void Hub.stop()
      RemoveToken()
      TokenManager.GetInstance().ClearTokens()
    },
  },
})
